import type { Component } from 'vue'
import ApiCrossedIcon from '@/vue/icons/design-system/api-crossed.svg'
import ApiIcon from '@/vue/icons/design-system/api.svg'
import BuildingUnitOutlineIcon from '@/vue/icons/design-system/building-unit-outline.svg'
import BuildingUnitSolidIcon from '@/vue/icons/design-system/building-unit-solid.svg'
import CalculatedMeterIcon from '@/vue/icons/design-system/calculated-meter.svg'
import DocumentCrossedIcon from '@/vue/icons/design-system/document-crossed.svg'
import HalfCircleIcon from '@/vue/icons/design-system/half-circle.svg'
import ESGWaterIcon from '@/vue/icons/design-system/esg-water.svg'
import GRESBLogoIcon from '@/vue/icons/design-system/gresb-logo.svg'
import GRESBScoresIcon from '@/vue/icons/design-system/gresb-scores.svg'
import IncludedMeterIcon from '@/vue/icons/design-system/included-meter.svg'
import LoadingIcon from '@/vue/icons/design-system/loading.svg'
import MeasuresIcon from '@/vue/icons/design-system/measures.svg'
import MeterOutlineIcon from '@/vue/icons/design-system/meter-outline.svg'
import MeterSolidIcon from '@/vue/icons/design-system/meter-solid.svg'
import OverviewIcon from '@/vue/icons/design-system/overview.svg'
import ReportMicroIcon from '@/vue/icons/design-system/report-micro.svg'
import ReportMiniIcon from '@/vue/icons/design-system/report-mini.svg'
import ReportOutlineIcon from '@/vue/icons/design-system/report-outline.svg'
import ReportSolidIcon from '@/vue/icons/design-system/report-solid.svg'
import ArrowRightFromLineIcon from '@/vue/icons/design-system/right-arrow-from-line.svg'
import StateSortDownIcon from '@/vue/icons/design-system/state-sort-down.svg'
import StateSortUpIcon from '@/vue/icons/design-system/state-sort-up.svg'
import StateSortIcon from '@/vue/icons/design-system/state-sort.svg'
import { createMultipleIconVariants, createSingleIconVariants } from '../helpers/iconVariants'

export const customIcons = {
    'api': createSingleIconVariants(ApiIcon as unknown as Component),
    'api-crossed': createSingleIconVariants(ApiCrossedIcon as unknown as Component),
    'arrow-right-from-line': createSingleIconVariants(ArrowRightFromLineIcon as unknown as Component),
    'building-unit': createMultipleIconVariants({
        solid: BuildingUnitSolidIcon as unknown as Component,
        outline: BuildingUnitOutlineIcon as unknown as Component,
        mini: BuildingUnitSolidIcon as unknown as Component,
        micro: BuildingUnitSolidIcon as unknown as Component,
    }),
    'calculated-meter': createSingleIconVariants(CalculatedMeterIcon as unknown as Component),
    'meter': createMultipleIconVariants({
        solid: MeterSolidIcon as unknown as Component,
        outline: MeterOutlineIcon as unknown as Component,
        mini: MeterSolidIcon as unknown as Component,
        micro: MeterSolidIcon as unknown as Component,
    }),
    'esg-water': createSingleIconVariants(ESGWaterIcon as unknown as Component),
    'gresb-logo': createSingleIconVariants(GRESBLogoIcon as unknown as Component),
    'gresb-scores': createSingleIconVariants(GRESBScoresIcon as unknown as Component),
    'included-meter': createSingleIconVariants(IncludedMeterIcon as unknown as Component),
    'loading': createSingleIconVariants(LoadingIcon as unknown as Component),
    'measures': createSingleIconVariants(MeasuresIcon as unknown as Component),
    'overview': createSingleIconVariants(OverviewIcon as unknown as Component),
    'report': createMultipleIconVariants({
        solid: ReportSolidIcon as unknown as Component,
        outline: ReportOutlineIcon as unknown as Component,
        mini: ReportMiniIcon as unknown as Component,
        micro: ReportMicroIcon as unknown as Component,
    }),
    'state-sort': createSingleIconVariants(StateSortIcon as unknown as Component),
    'state-sort-down': createSingleIconVariants(StateSortDownIcon as unknown as Component),
    'state-sort-up': createSingleIconVariants(StateSortUpIcon as unknown as Component),
    'document-crossed': createSingleIconVariants(DocumentCrossedIcon as unknown as Component),
    'half-circle': createSingleIconVariants(HalfCircleIcon as unknown as Component),
}
